import {
  formatTemplateAddress,
  formatTemplateContact,
  formatTemplateList,
  formatTemplateRate,
  formatTemplateTools,
  getTemplateQualification,
  getTemplateTitle,
} from './missionTemplateFormat';
import { formatRiskyPositions } from './missionTemplateRiskyPositions';

const Row = ({ label, value }) => (
  <div className="flex justify-between items-start gap-4 py-3 border-b border-gray-100 last:border-b-0">
    <span className="ft-sm text-gray-500 shrink-0">{label}</span>
    <span className="ft-sm text-gray-900 text-right break-words whitespace-pre-line max-w-[70%]">
      {value || '-'}
    </span>
  </div>
);

/** The job description as the company filled it, in the order of its own preview. */
const TemplateDetail = ({ template, riskyPositions }) => (
  <div className="flex flex-col">
    <Row label="Intitulé de la fiche" value={getTemplateTitle(template)} />
    <Row label="Secteur" value={template?.activity} />
    <Row label="Qualification" value={getTemplateQualification(template)} />
    <Row label="Matériel" value={formatTemplateTools(template?.tools)} />
    <Row label="Permis" value={formatTemplateList(template?.licences)} />
    <Row label="Langue" value={formatTemplateList(template?.language)} />
    <Row
      label="Poste à risque"
      value={formatRiskyPositions(template?.conditions, riskyPositions)}
    />
    <Row label="Adresse" value={formatTemplateAddress(template?.location)} />
    <Row label="Taux horaire brut" value={formatTemplateRate(template)} />
    <Row label="Responsable" value={formatTemplateContact(template)} />
    <Row label="Note intérimaire" value={template?.other} />
    <Row label="Note agence" value={template?.other_interim} />
  </div>
);

export default TemplateDetail;
